export default __webpack_public_path__ + "static/media/edit_employee.41100e02.svg";